<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="transform -translate-y-[10px] opacity-0"
    leave-active-class="transition-all duration-200 ease-in"
    leave-to-class="transform -translate-y-[10px] opacity-0"
  >
    <div
      v-if="visible"
      class="bg-warning2 border border-solid border-warning color-warning3 rounded flex items-center p-2 gap-x-4 gap-y-2 justify-between"
    >
      <div class="flex items-center gap-4">
        <CIcon icon="triangle-exclamation" size="16" />
        <div>{{ title }}</div>
      </div>

      <CIcon v-if="!persistent" class="cursor-pointer" icon="times-circle" size="20" @click="hide()" />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'

defineProps<{
  title: string
  visible: boolean
  persistent?: boolean
}>()

const emit = defineEmits<{
  'update:visible': [visible: boolean]
}>()

const hide = () => {
  emit('update:visible', false)
}
</script>
